import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { FC, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonIcon } from '../common/CommonIcon';

export const AchievementItemEmpty: FC = () => { 
  const { t } = useTranslation();
  const boxRef = useRef<HTMLDivElement>(null);
  const [boxHeight, setBoxHeight] = useState(0);
  useEffect(() => {
    const updateHeight = () => {
      if (boxRef.current) {
        setBoxHeight(boxRef.current.offsetHeight);
      }
    };
    
    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);
  
  const iconSize = useMemo(() => Math.round(boxHeight * 0.4), [boxHeight]);
  const titleFontSize = useMemo(() => Math.max(12, Math.round(boxHeight * 0.08)), [boxHeight]);
  const timeFontSize = useMemo(() => Math.max(9, Math.round(boxHeight * 0.06)), [boxHeight]);
  const timeIconSize = useMemo(() => Math.max(8, Math.round(boxHeight * 0.05)), [boxHeight]);
  const dynamicSpacing = useMemo(() => Math.max(0.5, boxHeight * 0.01), [boxHeight]);
  const dynamicPadding = useMemo(() => Math.max(4, boxHeight * 0.04), [boxHeight]);

  return (
    <Box ref={boxRef} sx={{
      backgroundColor: 'var(--tg-theme-section-bg-color)',
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
      height: '100%',
      width: '100%',
      flex: 1,
      minWidth: 0,
      overflow: 'hidden',
      padding: `${dynamicPadding}px`,
      paddingBottom: `${dynamicPadding+10}px`,
      boxSizing: 'border-box',
      opacity: 0.3,
      borderStyle: 'dashed',
      borderBottomLeftRadius: '48px',
      borderBottomRightRadius: '48px',
    }}>
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="flex-start"
        height="100%"
        gap={dynamicSpacing}
      >
        {/* Icon */}
        <Box sx={{ flexShrink: 0 }}>
            <CommonIcon
              icon="emoji-events"
              type="outlined"
              color="#ffffff"
              size={iconSize}
            />
        </Box>

        {/* Title */}
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', minHeight: 0, marginTop: '10px' }}>
          <Text
            weight="2"
            style={{
              color: '#ffffff',
              textAlign: 'center',
              whiteSpace: 'normal',
              fontSize: `${titleFontSize}px`,
              lineHeight: '1.2',
              wordBreak: 'break-word',
            }}
          >
            {t('achievement.emptySlotTitle')}
          </Text>
        </Box>

        {/* Time */}
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.5}
          sx={{ flexShrink: 0 }}
        >
          <CommonIcon 
            icon="access_time" 
            type="outlined" 
            color="#ffffff" 
            size={timeIconSize}
          />
          <Text style={{ 
            color: '#ffffff', 
            opacity: 0.8, 
            whiteSpace: 'nowrap', 
            fontSize: `${timeFontSize}px` 
          }}>
            {t('achievement.comingSoon')}
          </Text>
        </Stack>
      </Stack>
    </Box>
  );
};
